import { render, staticRenderFns } from "./task-map.vue?vue&type=template&id=cfe45ff6&"
import script from "./task-map.vue?vue&type=script&lang=ts&"
export * from "./task-map.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports